import { render } from "./GameCardSlider.vue?vue&type=template&id=e38d59d2"
import script from "./GameCardSlider.vue?vue&type=script&lang=js"
export * from "./GameCardSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__